const ae: {[key: string]: string} = {
    "header.menu.events": "الأحداث",
    "header.menu.terms_and_conditions": "البنود و الظروف",
    "header.menu.contact_us": "اتصل بنا",
}

export default ae;